import langDefaultTh from "./th/default.json";
import langDefaultEn from "./en/default.json";
import langDefaultCn from "./cn/default.json";

import langPaymentTh from "./th/payment.json";
import langPaymentEn from "./en/payment.json";
import langPaymentCn from "./cn/payment.json";

const locales = {
  languages: [
    {
      key: "th",
      name: "TH",
      data: {
        default: langDefaultTh,
        payment: langPaymentTh
      }
    },
    {
      key: "en",
      name: "EN",
      data: {
        default: langDefaultEn,
        payment: langPaymentEn
      }
    },
    {
      key: "cn",
      name: "CN",
      data: {
        default: langDefaultCn,
        payment: langPaymentCn
      }
    }
  ],
  defaultLanguage: "en"
};

export default locales;



// WEBPACK FOOTER //
// ./src/locales/index.js